import type React from 'react';
import {Stack, Typography} from '@mui/material';
import type {PlanProps} from '../strategyProps';
import {MatrixChart} from '../MatrixChart';

/** Power (A23): who depends on whom, for the top three suppliers. */
export const PowerTool: React.FC<PlanProps> = ({plan, actions}) => {
    const {content, derived, canEdit} = plan;
    return (
        <Stack direction={{xs: 'column', md: 'row'}} gap={3} alignItems="flex-start">
            <MatrixChart
                ariaLabel="Power matrix" xLabel="Supplier's dependence on you" yLabel="Your dependence on the supplier"
                quadrants={['Supplier dominant', 'Interdependent', 'Independent', 'Buyer dominant']}
                points={content.power.map((p, i) => ({id: String(i), label: p.name, x: p.x, y: p.y, color: '#0F8B8D'}))}
                readOnly={!canEdit}
                onMove={(id, x, y) => void actions.save('power',
                    content.power.map((p, i) => (String(i) === id ? {...p, x, y} : p)), 'Supplier moved.')}
            />
            <Stack gap={1.5} sx={{flex: 1}}>
                {content.power.length === 0 && <Typography variant="body2" color="text.secondary">No suppliers with spend.</Typography>}
                {content.power.map((p, i) => (
                    <div key={p.supplierId ?? p.name}>
                        <Typography variant="body2" fontWeight={600}>{`${p.name} · ${derived.power[i]?.quadrant}`}</Typography>
                        <Typography variant="body2" color="text.secondary">{derived.power[i]?.read}</Typography>
                    </div>
                ))}
            </Stack>
        </Stack>
    );
};
